import {fromJS} from 'immutable';
import configActions from '../actions/config.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    useEpicHeader: false,
    enableEarnings: false,
    epicFooter: {}
});

export const configReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;

    switch (action.type) {
        case configActions.TYPES.GET_APP_CONFIG:
            newState = newState.updateIn(['loading'], () => true);
            return newState;

        case configActions.TYPES.GET_APP_CONFIG_COMPLETE:
            newState = fromJS(action.payload);
            return newState;

        default:
            return newState;
    }
};

export default dieselReducer('config', configReducer);
